// extracted by mini-css-extract-plugin
export var typingIndicator = "_pd-0";